import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-leaf-soft py-12 sm:py-16" data-id="element-31" data-mp="1o3x23lbnuo1h">
      <div className="mx-auto flex max-w-3xl flex-col items-start gap-6 px-5 sm:flex-row sm:gap-8" data-id="element-32" data-mp="1o5q1qgnuw7zz">
        <BadgeCheckIcon className="h-14 w-14 shrink-0 text-leaf" strokeWidth={1.5} aria-hidden="true" data-id="element-33" data-mp="221bxr7sibs1w" />
        <div data-id="element-34" data-mp="19e7q0v214zmf">
          <h2 className="text-2xl font-black leading-tight tracking-tight text-ink" data-id="element-35" data-mp="19fskyls9akkt">
            Garantía de “Cabeza Limpia” de 7 días
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-36" data-mp="14dte31xb55j4">
            Si aplicas el método y no ves resultados inmediatos, o si sientes que no es
            para ti, te devolvemos el 100% de tu dinero. Sin preguntas.
          </p>
          <p className="mt-4 text-base font-bold text-ink" data-id="element-37" data-mp="qnhl70swf2qx">
            El riesgo es nuestro. El alivio es tuyo.
          </p>
        </div>
      </div>
    </section>;
}